
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const GAME_DURATION = 60; // 4 quarters × 15 seconds

const UpcomingMatchups = ({
    fantasyTeamDetailExchange = [],
}) => {

    const [currentTime, setCurrentTime] = useState(
        new Date()
    );

    // Update every second so status changes automatically
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const matches = [...fantasyTeamDetailExchange]
        .filter((match) => match?.scheduledate)
        .sort((a, b) => {
            return (
                new Date(a.scheduledate).getTime() -
                new Date(b.scheduledate).getTime()
            );
        });

    const getMatchStatus = (match) => {

        const startTime =
            new Date(match.scheduledate).getTime();

        const now = currentTime.getTime();

        const elapsedSeconds =
            Math.floor((now - startTime) / 1000);

        // Match has not started
        if (elapsedSeconds < 0) {
            return "UPCOMING";
        }

        // Match is currently running
        if (elapsedSeconds < GAME_DURATION) {
            return "LIVE";
        }

        // Match has finished
        return "COMPLETED";
    };

    const formatMatchDate = (match) => {

        const date = new Date(match.scheduledate);

        if (Number.isNaN(date.getTime())) {
            return {
                date: "",
                time: "",
            };
        }

        return {
            date: date.toLocaleDateString("en-US", {
                month: "short",
                day: "2-digit",
            }),

            time: date.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
            }),
        };
    };

    return (
        <aside className="schedule card">

            <h2>UPCOMING MATCHUPS</h2>

            <div className="schedule-matches">

                {matches.length > 0 ? (

                    matches.map((match) => {

                        const matchDate =
                            formatMatchDate(match);

                        const status =
                            getMatchStatus(match);

                        return (
                            <div
                                className="match"
                                key={match.gameid}
                            >

                                <div className="match-datetime">
                                    <strong>
                                        {matchDate.date}
                                    </strong>

                                    <small>
                                        {matchDate.time}
                                    </small>
                                </div>

                                <div className="match-teams">

                                    <div className="match-team">
                                        <img
                                            src={match.image_url_away}
                                            alt={match.TeamNameaway}
                                        />

                                        <span>
                                            {match.TeamNameaway}
                                        </span>
                                    </div>

                                    <b className="match-vs">
                                        VS
                                    </b>

                                    <div className="match-team">
                                        <img
                                            src={match.image_url_home}
                                            alt={match.TeamNamehome}
                                        />

                                        <span>
                                            {match.TeamNamehome}
                                        </span>
                                    </div>

                                </div>

                                {/* <div
                                    className={`match-status ${status.toLowerCase()}`}
                                >
                                    {status}
                                </div> */}

                            </div>
                        );
                    })

                ) : (
                    <div className="match">
                        <div>
                            No games scheduled
                        </div>
                    </div>
                )}

            </div>

            <Link
                to="/nba/games"
                className="btn btn-primary schedule-btn"
            >
                VIEW FULL SCHEDULE
            </Link>

        </aside>
    );
};

export default UpcomingMatchups;

